var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBodytype(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0002,
    cy: 8.71792,
    r: 4.61538,
    fill: "#BDD9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8457 20.5127C13.8457 17.1141 16.6009 14.3589 19.9995 14.3589C23.3982 14.3589 26.1534 17.1141 26.1534 20.5127V27.6922H13.8457V20.5127Z",
    fill: "#5AA0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8457 27.6924H18.9739V34.8719C18.9739 35.4383 18.5147 35.8975 17.9483 35.8975H14.8713C14.3049 35.8975 13.8457 35.4383 13.8457 34.8719V27.6924Z",
    fill: "#BDD9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0254 27.6924H26.1536V34.8719C26.1536 35.4383 25.6944 35.8975 25.128 35.8975H22.051C21.4846 35.8975 21.0254 35.4383 21.0254 34.8719V27.6924Z",
    fill: "#BDD9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2569 6.15381H8.20558C7.07269 6.15381 6.1543 7.0722 6.1543 8.20509V10.2564",
    stroke: "#FFD74B",
    strokeWidth: 2.05128,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7431 6.15381H31.7944C32.9273 6.15381 33.8457 7.0722 33.8457 8.20509V10.2564",
    stroke: "#FFD74B",
    strokeWidth: 2.05128,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7431 34.8716H31.7944C32.9273 34.8716 33.8457 33.9532 33.8457 32.8203V30.769",
    stroke: "#FFD74B",
    strokeWidth: 2.05128,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2569 34.8716H8.20558C7.07269 34.8716 6.1543 33.9532 6.1543 32.8203V30.769",
    stroke: "#FFD74B",
    strokeWidth: 2.05128,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBodytype);
export default __webpack_public_path__ + "static/media/ic_bodytype.86cf8b28b6110b2385e79580cd7d6d54.svg";
export { ForwardRef as ReactComponent };